var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner app-main-page" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMainList,
            expression: "showMainList"
          },
          {
            name: "loading",
            rawName: "v-loading.fullscreen.lock",
            value: _vm.fullscreenLoading,
            expression: "fullscreenLoading",
            modifiers: { fullscreen: true, lock: true }
          }
        ],
        staticClass: "app-main-inner app-main-page-tab",
        attrs: {
          type: "primary",
          "element-loading-text": "",
          "element-loading-spinner": "none",
          "element-loading-background": "rgba(170,170,170,0)"
        }
      },
      [
        _c(
          "div",
          { staticClass: "app-main-inner-row" },
          [
            _c("search-item", {
              attrs: { "config-module": "100", reset: true },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "app-main-inner-row row-grid" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "side-bar": {
                  toolPanels: ["columns", "filter"],
                  visible: false
                },
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-params": _vm.gridParams
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "app-main-inner-row row-pagination" },
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.filter.total > 0,
                  expression: "filter.total>0"
                }
              ],
              attrs: {
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize,
                "page-sizes": [10, 20, 30, 50, 100, 200, 500]
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }